export enum SearchStatus {
  INITIAL,
  SEARCHING,
  FINISHED,
  NO_RESULTS,
  ERROR,
}
